import { walkInTimeToMinutes } from "./time";

/**
 * Session windows (minutes past midnight), mirrored from city-discover time
 * ranges so walk-in can resolve which sessions are in play for a clock time.
 * Ranges intentionally overlap at meal boundaries, and between them they cover
 * the full day so walk-in never resolves to "no session".
 *
 * | Local time (HH:MM) | Sessions  |
 * | ------------------ | --------- |
 * | 00:00 – 11:00      | Breakfast |
 * | 10:00 – 16:00      | Lunch     |
 * | 15:00 – 24:00      | Dinner    |
 *
 * Examples: 10:30 → Breakfast + Lunch; 15:30 → Lunch + Dinner.
 */
const SESSION_RANGES: {
  session: SessionType;
  startMinutes: number;
  endMinutes: number;
}[] = [
  { session: "Breakfast", startMinutes: 0, endMinutes: 11 * 60 },
  { session: "Lunch", startMinutes: 10 * 60, endMinutes: 16 * 60 },
  { session: "Dinner", startMinutes: 15 * 60, endMinutes: 24 * 60 },
];

/**
 * Sessions whose discover time window contains `time` (`HHMM`).
 * Returns `[]` only when `time` is invalid — the windows cover every hour.
 */
export const getExpectedSessionTypes = (time: string): SessionType[] => {
  const minutes = walkInTimeToMinutes(time);
  if (minutes === null) {
    return [];
  }

  return [
    ...new Set(
      SESSION_RANGES.filter(
        ({ startMinutes, endMinutes }) =>
          minutes >= startMinutes && minutes <= endMinutes,
      ).map(({ session }) => session),
    ),
  ];
};
